export default __webpack_public_path__ + "static/media/children_information.c3a855b2.svg";